<template>
	<v-tooltip :text="symbolsStore.GUILabel('aa61c1b6-2b25-4f5e-a668-503b896ab1d3')" location="bottom" open-delay="500">
		<template v-slot:activator="{ props }">
			<v-btn
				v-bind="props"
				icon
				:color="compProps.color"
				variant="text"
				rounded="xl"
				size="x-small"
				class="pb-1 mr-2"
				style="width: 16px; height: 16px"
				@click="sendMessageText"
			>
				<v-icon :color="compProps.color">mdi-chat</v-icon>
			</v-btn>
		</template>
	</v-tooltip>
</template>

<script setup lang="ts">
import type { Word } from "@lr-notitia/notitia-alternis/schemas";
import { api } from "@lr-notitia/notitia-alternis/client";
import { useDomainStore } from "../../../store/domain";
import { useSessionStore } from "../../../store/alternis/session";
import { useAudioPlayerStore } from "../../../store/alternis/audioPlayer";
import { useSymbolsStore } from "../../../store/symbols";
import { Language, useAlternisNewStore } from "../../../store/alternis_new";
import { useInstanceWorkspacesStore } from "../../../store/i-workspace";
import { computed } from "vue";

const domainStore = useDomainStore();
const sessionStore = useSessionStore();
const audioPlayerStore = useAudioPlayerStore();
const symbolsStore = useSymbolsStore();
const alternisNewStore = useAlternisNewStore();
const instanceWorkspacesStore = useInstanceWorkspacesStore();

const isNewAlternis = computed(() => {
	return alternisNewStore.useNewAlternis;
});

const emits = defineEmits(["btn-click"]);
const compProps = defineProps({
	text: {
		type: String,
		required: true,
	},
	color: {
		type: String,
		required: false,
		default: "primary",
	},
});

function sendMessageText() {
	if (!compProps.text) return;
	emits("btn-click");

	if (isNewAlternis.value) {
		if (!instanceWorkspacesStore.openedWorkspaceId) return;
		alternisNewStore.sendTextMessage(
			domainStore.domain.id,
			instanceWorkspacesStore.openedWorkspaceId,
			compProps.text,
			{
				sender: alternisNewStore.sender,
				emitImmediately: true,
				language: domainStore.languagePreference as Language,
			},
		);
		return;
	} else {
		const words: Word[] = compProps.text.split(" ").map((word) => ({
			value: word,
			probability: 1,
		}));
		api()
			.message()
			.put(
				{
					words: words,
					lang:
						domainStore.languagePreference ||
						sessionStore.users.find((user) => user.userId === domainStore.account.id)?.lang ||
						"",
				},
				sessionStore.sessionId ?? "",
			)
			.then((d) => {
				let audioId = d.translation[domainStore.languagePreference]?.audioId;
				if (audioId) audioPlayerStore.play(audioId, 1);
				else if (d.audioId) audioPlayerStore.play(d.audioId, 1);
			});
	}
}
</script>
